import { render } from "./LoginLangSwitch.vue?vue&type=template&id=25a7bba6"
import script from "./LoginLangSwitch.vue?vue&type=script&lang=js"
export * from "./LoginLangSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gizmorilla.com/toolbox.gizmorilla.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__